import { render, staticRenderFns } from "./sceltaScontrini.vue?vue&type=template&id=57368f5c"
import script from "./sceltaScontrini.vue?vue&type=script&lang=js"
export * from "./sceltaScontrini.vue?vue&type=script&lang=js"
import style0 from "./sceltaScontrini.vue?vue&type=style&index=0&id=57368f5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports